pensionCpsService.$inject = ['$http', 'apiBase', '$q']

function pensionCpsService ($http, apiBase, $q) {
  var endpointPath = apiBase + 'v1'

  function cpsExport (data, refId) {
    console.log('data: ' + data + ' refID: ' + refId)
    var canceler = $q.defer()

    var promise = $http({
      url: endpointPath + '/pensions-applications/calculationParameters/' + refId,
      method: 'POST',
      timeout: canceler.promise,
      data: data
    })
    return {
      promise: promise,
      canceler: canceler
    }
  }
  return {
    cpsExport: cpsExport
  }
}

exports.pensionCpsService = pensionCpsService
